import { c as _c } from "react/compiler-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { CalendarDatePickerInput } from '@newfront-insurance/core-ui';
import { CalendarDate } from '@newfront-insurance/string-formatters';
import { useCallback, type JSX } from 'react';
interface Props {
  name: string;
  value?: string;
  setValue: (value?: string, shouldValidate?: boolean | undefined) => void;
  disabled?: boolean;
  isCompact?: boolean;
}
export function DateField(t0) {
  const $ = _c(10);
  const {
    name,
    value,
    setValue,
    disabled,
    isCompact
  } = t0;
  let t1;
  if ($[0] !== setValue) {
    t1 = newValue => {
      if (!newValue) {
        setValue(undefined);
        return;
      }
      setValue(newValue.toDate("UTC").toISOString());
    };
    $[0] = setValue;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onChange = t1;
  let t2;
  if ($[2] !== value) {
    t2 = value ? CalendarDate.fromDate(new Date(value)) : undefined;
    $[2] = value;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = isCompact ? "h-[30px]" : undefined;
  let t4;
  if ($[4] !== disabled || $[5] !== name || $[6] !== onChange || $[7] !== t2 || $[8] !== t3) {
    t4 = <CalendarDatePickerInput name={name} value={t2} onChange={onChange} disabled={disabled} className={t3} />;
    $[4] = disabled;
    $[5] = name;
    $[6] = onChange;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}